import { Link } from "gatsby"
import * as React from "react"

export const DefaultBottom = () => (
  <div className="default-banner has-background-light py-6">
    <div className="extra is-hidden-mobile is-hidden-tablet-only">
      <div className="extra-1"></div>
      <div className="extra-2">
        <img src="/img/extra/footer.svg" alt="" />
      </div>
    </div>
    <div className="content py-6 has-text-left">
      <div className="container">
        <div className="columns is-variable is-8">
          <article className="column">
            <h2 className="is-size-4 has-text-weight-bold mb-2">Get ahead</h2>
            <p id="get-ahead-description" className="mb-1">
              VMware offers training and certification to turbo-charge your
              progress.
            </p>
            <a
              className="is-link link-animate"
              href={"https://spring.academy/"}
              aria-labelledby="get-ahead-description"
            >
              Learn more
            </a>
          </article>
          <article className="column">
            <h2 className="is-size-4 has-text-weight-bold mb-2">Get support</h2>
            <p id="support-description" className="mb-1">
              Tanzu Spring offers support and binaries for OpenJDK™, Spring,
              and Apache Tomcat® in one simple subscription.
            </p>
            <Link
              className="is-link link-animate"
              to={"/support"}
              aria-labelledby="support-description"
            >
              Learn more
            </Link>
          </article>
          <article className="column">
            <h2
              className="is-size-4 has-text-weight-bold mb-2"
              id="upcoming-events-title"
            >
              Upcoming events
            </h2>
            <p className="mb-1">
              Check out all the upcoming events in the Spring community.
            </p>
            <Link
              aria-labelledby="upcoming-events-title"
              className="is-link link-animate"
              to={"/events"}
            >
              View all
            </Link>
          </article>
        </div>
      </div>
    </div>
  </div>
)
